// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "version": "2.25.2",
    "timestamp": "2025-06-26T20:16:18.215Z"
};
/* tslint:enable */
